import createCrudVuexModule from "@/store/crud";

export const riskDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/library/risk-definition",
  moduleName: `risk-definition`,
});

export const workspaceRiskDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/risk-definition",
});

export const managementRiskDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/risk-definition",
});

export const riskThreatDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/library/risk-threat-definition",
  moduleName: `risk-threat-definition`,
});

export const workspaceRiskThreatDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/risk-threat-definition",
});

export const managementRiskThreatDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/risk-threat-definition",
});

export const riskAppliedControl = createCrudVuexModule({
  namespaced: true,
  path: "/library/risk-applied-control",
  moduleName: `risk-applied-control`,
});

export const workspaceRiskAppliedControl = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/risk-applied-control",
});

export const managementRiskAppliedControl = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/risk-applied-control",
});

export const riskWeaknessDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/library/risk-weakness-definition",
  moduleName: `risk-weakness-definition`,
});

export const workspaceRiskWeaknessDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/risk-weakness-definition",
});

export const managementRiskWeaknessDefinition = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/risk-weakness-definition",
});
